import React from "react";
import { Helmet } from "react-helmet-async";
import { useGlobal } from "reactn";
import ClassSpecHeader from "../Common/ClassSpecHeader";
import BuildsTabNav from "../FilterManager/BuildsTabNav";
import FilterManager from "../FilterManager/FilterManager";
import { getFormattedNames } from "../../lib/wowHelpers";
import Banner from "components/Common/Banner";
import { MediaQuery, useResponsive } from "@outplayed/responsive";
import { FreestarLeftRail, FreestarRightRail } from "components/Ads/FreestarRails";

const Layout = (props) => {
  const { children, className, classType, filterPage, metaTitle, pageDescription, metaDescription, pageTitle, specType } = props;
  const { currentBreakpoint } = useResponsive();

  const isMobile =
    currentBreakpoint === "MOBILE_SMALL" || currentBreakpoint === "MOBILE_MEDIUM" || currentBreakpoint === "MOBILE_LARGE";
  const { displayClassName, displaySpecName } = getFormattedNames(classType, specType);

  return (
    <div className={`wow-layout-container ${className}`}>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
      {/* <Banner /> */}
      <div className="wow-base-content" id="wow-base-content">
        <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
          <div className="flex-1 min-w-0">
            <FreestarLeftRail className="sticky top-[calc(var(--header-height)+24px)]" />
          </div>
        </MediaQuery>
        <div
          className="wow-content"
          style={{
            backgroundImage: `url("https://static.bigbrain.gg/wow/background-images/specs/${classType}_${specType}-bg.jpg")`,
          }}
        >
          <ClassSpecHeader
            classType={classType}
            description={pageDescription}
            displayClassName={displayClassName}
            displaySpecName={displaySpecName}
            specType={specType}
            title={pageTitle}
          />
          <BuildsTabNav />
          <FilterManager page={filterPage} isMobile={isMobile} />
          {children}
        </div>
        <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
          <div className="flex-1 min-w-0">
            <FreestarRightRail className="sticky top-[calc(var(--header-height)+24px)]" />
          </div>
        </MediaQuery>
      </div>
    </div>
  );
};

export default Layout;
